import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { createCartProduct } from "../../../../shared/hooks/useFetchServiceDetails";
import API_URLS from "../../Utils/axr";
import store from "../store";
import { PURGE } from "redux-persist";
import { getForIQRemove } from "../../Utils/util-functions";
import DwLogutil from "../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../shared/utils/Constants";
 
interface CartState {
  cartResponse: any;
  loading: boolean;
  createCartResp:any;
  error: string | null;
}
 
const initialState: CartState = {
  cartResponse: null,
  loading: false,
  error: null,
  createCartResp: null
};
 
// Async thunk for creating a cart

export const createV2Cart = createAsyncThunk(

  "createProductCart/shopExp",

  async ({listItems, voiceRemoved = false,iQremoved=false,dslMigratorEligible=false,isPostPaidFiberUser=false,productType="",optionalFeatureList=[]}:{listItems: any, voiceRemoved?: boolean,iQremoved?:boolean,dslMigratorEligible?: boolean,isPostPaidFiberUser?: boolean , productType?: string, optionalFeatureList?: any[]},  {rejectWithValue} ) => {
    try {
      const reduxStore = store.getState();
      const addressQualificationData  = reduxStore?.addressQualification?.data?.addressQualification?.entity
      const selectedInternet= reduxStore?.InternetProductsState?.currentProduct?.offerResponse?.offerDetails;
      
      const headers = reduxStore?.brightspeedToken?.headers;

      const addressId = addressQualificationData?.addressId;

      const siteId = addressQualificationData?.siteId || headers?.siteId ;

      const wireCenter = addressQualificationData?.wireCenter;

      const transactionId = addressQualificationData?.partnerSessionId || "brspd-"+headers?.sessionId;

      const channel = "web-acm";
      const isSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;
      const isMoveSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isMoveSupplementOrderEligible;
      const cancelVoiceData = reduxStore?.getAccordionStateSlice?.cancelVoice;
      const user = reduxStore?.user?.data;
      const affinityDiscountApplicable = reduxStore?.planDetails?.planDetails && reduxStore?.planDetails?.planDetails?.discountPlans?.find((affinityApplicable:any) => affinityApplicable?.productName?.includes("Affinity Discount"));
      const internetExists = reduxStore?.InternetProductsState?.internetExist ;
      const internetPlanPriceExisting = reduxStore?.planDetails?.ctlPlanDetails?.[0]?.internet?.amount; 
      const selectedInternetChanged = reduxStore?.getAccordionStateSlice?.selectedInternetChanged;
      let url_new=API_URLS["createCart"];
      const cartProductPostData = {

        baseline: {
          transactionId,
          channel : channel,
          wirecenter: wireCenter,
          workflow: isMoveSupplementOrderEnabled ? "mover" : isSupplementOrderEnabled ? "buyflow":  "change",
          revisionType: isMoveSupplementOrderEnabled ? "supplement" : "",
          siteId,
          partnerOrderId: transactionId,
          ...(isSupplementOrderEnabled && {
            billingType: user?.billingType,
            partnerId: "BS196123",
            salesCode: "20000660",
          }),
          ...(dslMigratorEligible && user?.billingType?.toLowerCase() === "prepaid" ? { intent: "dsl_migration" } : {intent: ""}),
          ...(dslMigratorEligible && {
            billingType: user?.billingType,
            partnerId: "BS196123",
            salesCode: "20000660",
            siteId: "bs",
            workflow: "migratecoppertofiber",
            partnerReferenceId: "",
            agentId: "fjdsalfsakdf@fsafsda.com",
         }),


        },

        currency: "USD",

        cartId: "",

        lineItems: listItems,
        ...(localStorage.getItem("downgradeWifi") === "DOWN" && { cartAddOnsAction: "remove" }),
        // ... ( listItems.filter((item:any)=>item.itemActionType==="remove").length>0 && { cartAddOnsAction: "remove" }),
        ...(voiceRemoved && { cartAddOnsAction: "remove" }),
        ...((localStorage.getItem("iqRemoved") ) && { cartAddOnsAction: "remove" }),
        ...((dslMigratorEligible || isPostPaidFiberUser || productType) && { productType: productType }),  // Changes for DSL MIGRATION FLOW
        shippingAddress: {
          id: addressId,
          streetName: addressQualificationData?.address,
          additionalStreetInfo: "",
          postalCode: addressQualificationData?.postalCode,
          city: addressQualificationData?.city,
          state: addressQualificationData?.state,
          country: "US",
          wirecenter: wireCenter,
          ...(dslMigratorEligible && {key: addressQualificationData?.fullAddress,}),  // Changes for DSL MIGRATION FLOW
        },
      
        ...((((affinityDiscountApplicable && !internetExists) && ((affinityDiscountApplicable?.affinityOccupation === 'Student') ||  (affinityDiscountApplicable?.affinityOccupation === 'Teacher') ||  affinityDiscountApplicable?.affinityOccupation === 'Military')))) ?
        {
          "customerGroup": {
            "key": affinityDiscountApplicable?.affinityOccupation,
            "typeId": "customer-group"
          }
        }
        :
        {
        "customerGroup": {
        "key":(dslMigratorEligible && user?.billingType?.toLowerCase() === "prepaid") ? "DSLTOFIBER" : "BS-Normal-User",
        "typeId": "customer-group",
       
      },
 },
      ...(process.env.REACT_APP_TARGET_UPSELL === "true" && selectedInternetChanged && (productType === "FD" || (user?.billingType?.toLowerCase() === "prepaid")) && {
        "dynamicPrice": selectedInternet?.dynamicPrice,
        "dynamicPriceType": selectedInternet?.dynamicPriceType,
        ...(isPostPaidFiberUser ? { "currentPlanPrice": internetExists ? internetPlanPriceExisting : selectedInternet?.priceResult?.[0]?.productCharge } : { "rackPriceDifference": selectedInternet?.rackPriceDifference }),
      }),

      };
      const params = {

        "": [url_new],

      };
      const response = await createCartProduct(params, cartProductPostData, headers);      
      const messageStatus = response?.data?.messageStatus?.find((item: any) => "statusCode" in item);
      
      if (messageStatus?.statusCode === "200") {
        // localStorage.setItem('cartResponse',JSON.stringify(response?.data?.cartResponse));
        return response?.data?.cartResponse;

      } else {

        return rejectWithValue(response.data);

      }

    } catch (error: any) {

       return rejectWithValue(error.toString());

    }

  }

);
 
// Async thunk for updating a cart

export const updateV2Cart = createAsyncThunk(

  "updateProductCart/shopExp",

  async ({listItems, voiceRemoved = false,iQremoved=false,dslMigratorEligible=false,isPostPaidFiberUser=false, productType="",optionalFeatureList}:{listItems: any, voiceRemoved?: boolean,iQremoved?:boolean,dslMigratorEligible?: boolean,isPostPaidFiberUser?: boolean, productType?: string, optionalFeatureList?: any },  {rejectWithValue} ) => {

    try {
      const reduxStore = store.getState();
      const addressQualificationData  = reduxStore?.addressQualification?.data?.addressQualification?.entity

      const headers = reduxStore?.brightspeedToken?.headers;

      const { sessionId } = reduxStore?.user;

      const addressId = addressQualificationData?.addressId;

      const siteId = addressQualificationData?.siteId || headers?.siteId;

      const wireCenter = addressQualificationData?.wireCenter;

      const transactionId = addressQualificationData?.partnerSessionId;


      const channel = "web-acm";
      const isSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;
      const isMoveSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isMoveSupplementOrderEligible;
      const cartId  = reduxStore?.cartSlice?.cartResponse?.cartId;
      const affinityDiscountApplicable = reduxStore?.planDetails?.planDetails && reduxStore?.planDetails?.planDetails?.discountPlans?.find((affinityApplicable:any) => affinityApplicable?.productName?.includes("Affinity Discount"));
      // const affinityDiscountZuoraResponse = reduxStore?.fetchOrderDetailsv2?.existingOrderDetails && reduxStore?.fetchOrderDetailsv2?.existingOrderDetails?.discountPlans?.find((affinityApplicable:any) => affinityApplicable?.productName?.includes("Affinity Discount"));
      const affinityOccupation = (affinityDiscountApplicable && affinityDiscountApplicable?.affinityOccupation) ;
      const internetExists = reduxStore?.InternetProductsState?.internetExist
      const internetPlanPriceExisting = reduxStore?.planDetails?.ctlPlanDetails?.[0]?.internet?.amount;    
      const user = reduxStore?.user?.data;
      const selectedInternet= reduxStore?.InternetProductsState?.currentProduct?.offerResponse?.offerDetails;
      const selectedInternetChanged = reduxStore?.getAccordionStateSlice?.selectedInternetChanged;

      const cartProductPostData = {

        baseline: {

          transactionId:transactionId,

          channel :  channel,

          wirecenter: wireCenter,
          workflow: isMoveSupplementOrderEnabled ? "mover" : isSupplementOrderEnabled ? "buyflow" : "change",
          revisionType: isMoveSupplementOrderEnabled ? "supplement" : "",
          siteId,
          partnerOrderId: transactionId,
           
          ...(isSupplementOrderEnabled && {
            billingType: user?.billingType,
            partnerId: "BS196123",
            salesCode: "20000660",
          }), 
            ...(dslMigratorEligible && user?.billingType?.toLowerCase() === "prepaid" ? { intent: "dsl_migration" } : {intent: ""}),
            ...(dslMigratorEligible && {
            billingType: user?.billingType,
            partnerId: "BS196123",
            salesCode: "20000660",
            siteId: "bs",
            workflow: "migratecoppertofiber",
            agentId: "fjdsalfsakdf@fsafsda.com",
            partnerReferenceId: "",
         }),
        },

        cartId: reduxStore?.cartSlice?.cartResponse?.cartId,

        actions: listItems,

         ...(localStorage.getItem("downgradeWifi") &&  { cartAddOnsAction: "remove" }),
        ...((voiceRemoved) &&{ cartAddOnsAction: "remove" }),
        ...((localStorage.getItem("iqRemoved")) &&{ cartAddOnsAction: "remove" }),
        ...((dslMigratorEligible || isPostPaidFiberUser || productType) && { productType: productType }),  // Changes for DSL MIGRATION FLOW
        ...(dslMigratorEligible && { optionalFeatureList: optionalFeatureList }),  // Changes for DSL MIGRATION FLOW
        
        ...(process.env.REACT_APP_TARGET_UPSELL === "true" && selectedInternetChanged && (productType === "FD" || user?.billingType?.toLowerCase() === "prepaid" && selectedInternet) && {
          "dynamicPrice": selectedInternet?.dynamicPrice,
          "dynamicPriceType": selectedInternet?.dynamicPriceType,
          ...(isPostPaidFiberUser ? { "currentPlanPrice": internetExists ? internetPlanPriceExisting : selectedInternet?.priceResult?.[0]?.productCharge } : { "rackPriceDifference": selectedInternet?.rackPriceDifference }),
        }),

        "discountType": (affinityDiscountApplicable && !internetExists) ? "Affinity" : "",
        ...(((((affinityDiscountApplicable ) && !internetExists) && ((affinityDiscountApplicable?.affinityOccupation === 'Student') ||  (affinityDiscountApplicable?.affinityOccupation === 'Teacher') ||  affinityDiscountApplicable?.affinityOccupation === 'Military')))) ?
        {
          "customerGroup": {
            "key": affinityOccupation,
            "typeId": "customer-group"
          }
        }
        :
        {
            "customerGroup": {
              "key": (dslMigratorEligible && user?.billingType?.toLowerCase() === "prepaid") ? "DSLTOFIBER" : "BS-Normal-User",
              "typeId": "customer-group",
            },

      },
        wirecenter: wireCenter,

      };
      let url=API_URLS?.updateCart;
      const params = {

        "": [url],

      };
 
      const response = await createCartProduct(params, cartProductPostData, headers);

      const messageStatus = response?.data?.messageStatus?.find((item: any) => "statusCode" in item);

      if (messageStatus?.statusCode === "200") {
        // localStorage.setItem('cartResponse',JSON.stringify(response?.data?.cartResponse));
        return response?.data?.cartResponse;
        
      } else {

        DwLogutil({
          stepName: EC_DW_LOGGING_STEPS.update_cart_submission_fail,
          error: response?.data,
          message: `updateCart failed. Product type: ${productType || "missing"}. Action count: ${Array.isArray(listItems) ? listItems.length : 0}.`,
          response: JSON.stringify(response?.data),
        });

        return rejectWithValue(response.data);

      }
  
    } catch (error: any) {

      DwLogutil({
        stepName: EC_DW_LOGGING_STEPS.update_cart_submission_fail,
        error,
        message: `updateCart failed. Product type: ${productType || "missing"}. Action count: ${Array.isArray(listItems) ? listItems.length : 0}.`,
      });

      return rejectWithValue(error.toString());

    }

  }

);
 
// Cart slice

const cartSlice = createSlice({

  name: "cart",

  initialState,

  reducers: {

    resetCartState: (state) => {

      state.cartResponse = null;

      state.loading = false;

      state.error = null;

    },
    updateCartResponseManually:(state,action)=>{
      state.cartResponse=action.payload;
    }

  },

  extraReducers: (builder) => {

    // createV2Cart

    builder.addCase(createV2Cart.pending, (state) => {

      state.loading = true;

      state.error = null;

    });

    builder.addCase(createV2Cart.fulfilled, (state, action: PayloadAction<any>) => {

      state.loading = false;

      state.cartResponse = action.payload;
      state.createCartResp = action.payload;

    });

    builder.addCase(createV2Cart.rejected, (state, action) => {

      state.loading = false;

      state.error = action.payload as string;

    });

    // updateV2Cart

    builder.addCase(updateV2Cart.pending, (state) => {

      state.loading = true;

      state.error = null;
      state.createCartResp=state.cartResponse;

    });

    builder.addCase(updateV2Cart.fulfilled, (state, action: PayloadAction<any>) => {

      state.loading = false;
      // fix - check for remove THIC is exist in prev response and not next call 
      let _resp= getForIQRemove(state.createCartResp,action.payload);
      state.cartResponse = _resp;

    });

    builder.addCase(updateV2Cart.rejected, (state, action) => {

      state.loading = false;

      state.error = action.payload as string;

    });

    builder.addCase(PURGE, () => {
      return  initialState;
    });

  },

});
 
export const { resetCartState,updateCartResponseManually } = cartSlice.actions;

export default cartSlice.reducer;

 